/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import hasProp from '@stdlib/assert-has-property';


// MAIN //

/**
* Tests whether an object has a list of properties.
*
* @private
* @param {Object} obj - input object
* @param {Array<string>} keys - list of property names
* @returns {boolean} result
*/
function hasProperties( obj, keys ) {
	var i;
	for ( i = 0; i < keys.length; i++ ) {
		if ( !hasProp( obj, keys[ i ] ) ) {
			return false;
		}
	}
	return true;
}


// EXPORTS //

export default hasProperties;
